/* eslint-disable import/no-cycle */
import { connect } from 'react-redux';
import { getTerritoryPresets } from 'redux-core/territories/actions';

const mapDispatchToProps = {
  getTerritoryPresets,
};

export default connect(undefined, mapDispatchToProps);
